module.exports = "<div class=\"content\">\n  <ngx-loading [show]=\"loading\"></ngx-loading>\n  <div class=\"row\">\n    <message-box [messages]=\"errorMessages\"></message-box>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login-keycloak-callback/login-keycloak-callback.component.html
// module id = ./src/app/login-keycloak-callback/login-keycloak-callback.component.html
// module chunks = main